<template>
    <div class="vip_box">
        <MaskLoading v-if="isShow"></MaskLoading>
        <img src="../../assets/special/zanwu.jpg" alt="" class="welfare" v-if="isMobile">
        <img src="../../assets/special/zanwu_pc.jpg" alt="" class="welfare" v-else>
        <div class="special_box">
            <backSpecial></backSpecial>
            <div class="activity">
                <img v-for="(item, index) in HDList" :key="index"
                    :src="baseUrl + (isMobile ? item.ImgSrc : item.PcImgSrc)" alt="" class="activity_img cupo"
                    @click="nav(item.Link)">
            </div>
        </div>

    </div>
</template>

<script>
import Mixins from "../../script/getMobile";
import backSpecial from "@/components/backSpecial.vue"
import MaskLoading from "@/components/maskLoading.vue";
export default {
    name: "",
    mixins: [Mixins],
    data() {
        return {
            isShow: true,
            HDList: []
        }
    },
    components: {
        backSpecial,
        MaskLoading
    },
    mounted() {
        this.getList();
    },
    methods: {
        async getList() {
            var res = await this.$api.indexHuoDong({ finished: 0 });
            this.HDList = res.resultBody;
            setTimeout(() => {
                this.isShow = false;
            }, 200)
        },
        nav(url) {
            if (url) {
                if (url.indexOf('http') > -1) {
                    location.href = url;
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.vip_box {
    .special_box {
        padding: 20px 20px;
        max-width: 1200px;
        margin: auto;
    }

    background-color: #f8f8f8;
    min-height: 100vh;

    .welfare {
        width: 100%;
        display: block;
    }

    .activity {
        display: flex;
        flex-wrap: wrap;

        .activity_img {
            width: 32%;
            display: block;
            margin-right: 2%;
            margin-bottom: 20px;
            border-radius: 20px;
        }

        .activity_img:nth-child(3n) {
            margin-right: 0%;
        }
    }



    @media screen and (max-width: 800px) {
        .activity {
            display: block;

            .activity_img {
                width: 100%;
                margin-right: 0;
                border-radius: 15px;
            }
        }



    }
}
</style>